import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { createContext, memo, useCallback, useMemo, useState } from 'react';
export const TabNavBarContext = /*#__PURE__*/createContext();
function TabNavBarContainer(_ref) {
  let {
    children,
    defaultActiveKey = 0,
    navItems = [],
    topOffset = 0,
    ...rest
  } = _ref;
  const activeKeyValue = {};
  navItems.forEach(nav => {
    activeKeyValue[nav.eventKey] = null;
  });
  activeKeyValue[defaultActiveKey] = defaultActiveKey;
  const [activeKeysState, setActiveKeys] = useState(activeKeyValue);
  const getActiveKey = () => {
    const activeKeys = {
      ...activeKeysState
    };
    const key = Object.keys(activeKeys).find(k => activeKeys[k]);
    return activeKeys[key];
  };
  const handleContentVisible = useCallback(key => {
    const activeKeys = {
      ...activeKeysState
    };
    // instead of true/false, we'll keep the key value so we don't break the data type (number, string)
    activeKeys[key] = key;
    setActiveKeys(activeKeys);
  }, [activeKeysState]);
  const handleContentLeave = useCallback(key => {
    const activeKeys = {
      ...activeKeysState
    };
    const allActiveKeys = Object.keys(activeKeys).filter(k => activeKeys[k]);

    // make sure there is at least one tab selected
    if (allActiveKeys.length > 1) {
      activeKeys[key] = null;
      setActiveKeys(activeKeys);
    }
  }, [activeKeysState]);
  const activeKey = getActiveKey();
  delete rest.uiContext;
  delete rest.isNav;
  const providerValue = useMemo(() => ({
    onContentVisible: handleContentVisible,
    onContentLeave: handleContentLeave,
    activeKey,
    defaultActiveKey,
    navItems,
    topOffset
  }), [handleContentVisible, handleContentLeave, activeKey, defaultActiveKey, navItems, topOffset]);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": "TabNavBarContainer"
  }, rest), /*#__PURE__*/_jsx(TabNavBarContext.Provider, {
    value: providerValue
  }, void 0, children));
}
export default /*#__PURE__*/memo(TabNavBarContainer);